module.exports = __webpack_public_path__ + "static/media/70.5d11a86a.svg";